import { Reducer } from 'redux';
import { CorrespondenceActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  reportCorrespondences: [],
};

type ICorrespondenceStoreState = Readonly<typeof initialState>;

const reducer: Reducer<ICorrespondenceStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CorrespondenceActionTypes.GET_CORRESPONDENCE: {
      let _state = { ...state };
      _state = { ..._state, reportCorrespondences: action.value };
      return _state;
    }
    case CorrespondenceActionTypes.CLEAR_CORRESPONDENCE: {
      let _state = { ...state };
      _state = { ..._state, reportCorrespondences: [] };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
